module.exports = __webpack_public_path__ + "img/pic-02.77411513.png";